<template>
    <div class="main">
        <c-panel title="PLANEJAMENTO DE AULA" titleIcon="fas fa-pencil-ruler">
            <el-form label-position="top" @submit.native.prevent>
                <el-row v-if="precisaSelecionarInstituicao" :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Instituição">
                            <el-select v-model="instituicaoId" filterable clearable placeholder="Selecione a instituição" @change="onInstituicaoChange" style="width: 100%;">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Turma (opcional)">
                            <el-select v-model="filtro.turma_id" filterable clearable placeholder="Todas as turmas" @change="aplicarFiltro" style="width: 100%;">
                                <el-option v-for="t in turmas" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Data da aula (opcional)">
                            <el-date-picker v-model="filtro.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" clearable placeholder="Qualquer data" @change="aplicarFiltro" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-loading="carregando">
                <div v-if="planejamentos.length" class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 70px;">Nº</th>
                                <th style="width: 175px;">Data</th>
                                <th>Turma</th>
                                <th style="width: 170px;">Disciplina</th>
                                <th>Habilidades</th>
                                <th style="width: 110px;" class="u-text-center">Situação</th>
                                <th style="width: 130px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p in planejamentos" :key="p.id">
                                <td>{{ p.id }}</td>
                                <td>{{ intervaloData(p) }}</td>
                                <td>{{ nomeTurma(p.turma_id) }}</td>
                                <td>{{ nomeDisciplina(p.turma_id, p.disciplina_id) }}</td>
                                <td>{{ truncar(p.habilidades) }}</td>
                                <td class="u-text-center">
                                    <el-tag :type="p.aprovado ? 'success' : 'info'" size="mini">{{ p.aprovado ? 'Aprovado' : 'Pendente' }}</el-tag>
                                </td>
                                <td class="u-text-center">
                                    <el-button @click="abrirVisualizar(p)" type="primary" size="mini" icon="el-icon-view" plain>VISUALIZAR</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="u-text-center u-mt-15" v-if="paginacao.total > paginacao.per_page">
                        <el-pagination
                            background
                            layout="prev, pager, next, total"
                            :current-page="paginacao.current_page"
                            :page-size="paginacao.per_page"
                            :total="paginacao.total"
                            @current-change="mudarPagina">
                        </el-pagination>
                    </div>
                </div>

                <div v-else-if="!carregando" class="u-text-center" style="padding: 40px 0; color: #909399;">
                    {{ mensagemVazio }}
                </div>
            </div>

            <el-dialog title="Visualizar Planejamento" :visible.sync="modalVisivel" width="800px">
                <el-form label-position="top" :model="form" ref="formRef">
                    <el-row :gutter="10" class="u-mt-20">
                        <el-col :xs="24" :sm="form.disciplina_id ? 12 : 24">
                            <el-form-item label="Período">
                                <el-input :value="intervaloData(form)" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="form.disciplina_id" :xs="24" :sm="12">
                            <el-form-item label="Disciplina">
                                <el-input :value="nomeDisciplina(form.turma_id, form.disciplina_id)" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="form.competencia" :gutter="10">
                        <el-col :xs="24">
                            <el-form-item label="Competência (campo de experiência)">
                                <el-input :value="form.competencia" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Habilidades">
                                <el-input type="textarea" :rows="3" readonly v-model="form.habilidades"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Conteúdos">
                                <el-input type="textarea" :rows="3" readonly v-model="form.conteudos"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Conceitos">
                                <el-input type="textarea" :rows="3" readonly v-model="form.conceitos"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Atividades">
                                <el-input type="textarea" :rows="3" readonly v-model="form.atividades"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Metodologia">
                                <el-input type="textarea" :rows="3" readonly v-model="form.metodologia"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Avaliação">
                                <el-input type="textarea" :rows="3" readonly v-model="form.avaliacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="Observações (do professor)">
                                <el-input type="textarea" :rows="2" readonly v-model="form.observacoes"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <c-panel title="Análise do Coordenador Pedagógico" titleIcon="fas fa-user-check" style="margin-top: 15px;">
                        <el-form-item label="Observação do coordenador">
                            <el-input type="textarea" :rows="3" v-model="form.observacao_coordenador" placeholder="Registre aqui a análise/observação sobre este planejamento"></el-input>
                        </el-form-item>
                        <div class="u-text-right u-mt-10">
                            <el-button type="primary" :loading="salvandoObservacao" @click="salvarObservacaoCoordenador">SALVAR OBSERVAÇÃO</el-button>
                        </div>
                    </c-panel>

                    <c-panel v-if="turmaUsaDetalhesInfantil" title="Detalhes — Ed. Infantil / Fund. Anos Iniciais" titleIcon="fas fa-child" style="margin-top: 15px;">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Leitura">
                                    <el-input type="textarea" :rows="2" readonly v-model="form.detalhes_leitura"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Recursos">
                                    <el-input type="textarea" :rows="2" readonly v-model="form.detalhes_recursos"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Habilidades específicas">
                                    <el-input type="textarea" :rows="2" readonly v-model="form.detalhes_habilidades"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Aprendizagem">
                                    <el-input type="textarea" :rows="2" readonly v-model="form.detalhes_aprendizagem"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </c-panel>
                </el-form>
                <span slot="footer">
                    <span style="float: left; padding-top: 8px;">
                        <el-tag v-if="form.aprovado" type="success" size="small"><i class="el-icon-circle-check"></i> Planejamento aprovado</el-tag>
                        <el-tag v-else type="info" size="small">Pendente de aprovação</el-tag>
                    </span>
                    <el-button v-if="!form.aprovado" type="success" icon="el-icon-circle-check" :loading="salvandoAprovacao" @click="aprovar">APROVAR</el-button>
                    <el-button v-else type="warning" icon="el-icon-refresh-left" :loading="salvandoAprovacao" @click="desaprovar">REVERTER APROVAÇÃO</el-button>
                    <el-button @click="modalVisivel = false">FECHAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
const FORM_VAZIO = {
    id: null, turma_id: null, disciplina_id: null, data: null, data_fim: null,
    competencia: '', habilidades: '', conteudos: '', conceitos: '',
    atividades: '', metodologia: '', avaliacao: '', observacoes: '',
    observacao_coordenador: '', aprovado: false, aprovado_em: null,
    detalhes_leitura: '', detalhes_recursos: '', detalhes_habilidades: '', detalhes_aprendizagem: ''
}

export default {
    data: () => ({
        turmas: [],
        filtro: { turma_id: null, data: null },
        planejamentos: [],
        paginacao: { current_page: 1, per_page: 30, total: 0, last_page: 1 },
        carregando: false,
        modalVisivel: false,
        form: { ...FORM_VAZIO },
        turmaUsaDetalhesInfantil: false,
        instituicaoId: '',
        salvandoObservacao: false,
        salvandoAprovacao: false
    }),
    computed: {
        // SMED/NTI (tipos 4,5,6,7,8,10) não têm instituição vinculada; escolhem a escola nesta tela
        // (mesmo critério do turma/list). Fica sempre visível para eles, permitindo trocar.
        precisaSelecionarInstituicao () {
            const t = Number(this.$store.state.user.tipo)
            return (t > 3 && t <= 8) || t === 10
        },
        // Instituição ativa (escola vinculada ou selecionada pelo SMED).
        instituicaoAtivaId () {
            const inst = this.$store.state.config.instituicao
            return (inst && inst.id) ? inst.id : null
        },
        mensagemVazio () {
            return this.instituicaoAtivaId ? 'Nenhum registro encontrado.' : 'Selecione uma instituição para visualizar os planejamentos.'
        }
    },
    mounted () {
        // Reflete a instituição ativa (se já houver uma) no seletor, carrega as turmas
        // dela e já lista os últimos planejamentos lançados (sem exigir filtros).
        if (this.$store.state.config.instituicao && this.$store.state.config.instituicao.id) {
            this.instituicaoId = this.$store.state.config.instituicao.id
        }
        this.carregarTurmas()
        this.load()
    },
    methods: {
        async onInstituicaoChange () {
            // Define a instituição ativa (mesmo padrão do turma/list) e recarrega as turmas.
            await this.$store.dispatch('setInstituicao', this.instituicaoId)
            this.filtro.turma_id = null
            this.filtro.data = null
            this.turmas = []
            this.carregarTurmas()
            this.load(1)
        },
        carregarTurmas () {
            const inst = this.$store.state.config.instituicao
            const periodo = this.$store.state.config.periodo
            if (!inst || !inst.id || !periodo || !periodo.id) { this.turmas = []; return }

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${inst.id}/${periodo.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                // getAllTurmas retorna agrupado por curso ({ "CURSO": [turmas...] }); achata em lista única.
                const grupos = r.data || {}
                const lista = []
                Object.keys(grupos).forEach(c => (grupos[c] || []).forEach(t => lista.push(t)))
                this.turmas = lista
            })
            .catch(() => { this.turmas = [] })
        },
        aplicarFiltro () {
            this.load(1)
        },
        mudarPagina (page) {
            this.load(page)
        },
        load (page = 1) {
            const instId = this.instituicaoAtivaId
            if (!instId) {
                this.planejamentos = []
                this.paginacao = { current_page: 1, per_page: 30, total: 0, last_page: 1 }
                return
            }

            const periodo = this.$store.state.config.periodo
            const payload = {
                instituicao_id: instId,
                periodo_letivo_id: (periodo && periodo.id) ? periodo.id : null,
                turma_id: this.filtro.turma_id || null,
                de: this.filtro.data || null,
                ate: this.filtro.data || null,
                page
            }

            this.carregando = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-aula/getAllPaginate`,
                payload,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.carregando = false
                const d = r.data || {}
                this.planejamentos = d.data || []
                this.paginacao = {
                    current_page: d.current_page || 1,
                    per_page: d.per_page || 30,
                    total: d.total || 0,
                    last_page: d.last_page || 1
                }
            }).catch(() => {
                this.carregando = false
                this.planejamentos = []
                this.paginacao = { current_page: 1, per_page: 30, total: 0, last_page: 1 }
            })
        },
        // Tela web é somente leitura do plano: quem cria/edita/exclui é o docente no diário
        // eletrônico. A única parte editável aqui é a análise do coordenador (item 7).
        abrirVisualizar (p) {
            this.form = { ...FORM_VAZIO, ...p }
            // Detalhes infantis dependem da etapa do curso da turma DO PLANO (não do filtro).
            const t = this.turmas.find(x => x.id === p.turma_id)
            const etapa = (t && t.curso) ? t.curso.etapa : null
            this.turmaUsaDetalhesInfantil = (etapa === 0 || etapa === 1 || etapa === '0' || etapa === '1')
            this.modalVisivel = true
        },
        salvarObservacaoCoordenador () {
            if (!this.form.id) return
            this.salvandoObservacao = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-aula/observacaoCoordenador/${this.form.id}`,
                { observacao: this.form.observacao_coordenador },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.salvandoObservacao = false
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Observação salva com sucesso.', type: 'success' })
                // Reflete no item da listagem carregado em memória.
                const item = this.planejamentos.find(x => x.id === this.form.id)
                if (item) item.observacao_coordenador = this.form.observacao_coordenador
            }).catch(e => { this.salvandoObservacao = false; this.$store.commit('throwException', e) })
        },
        aprovar () {
            this.acaoAprovacao('aprovar', true, 'Planejamento aprovado. O professor não poderá mais editá-lo.')
        },
        desaprovar () {
            this.$confirm('Reverter a aprovação? O professor voltará a poder editar este planejamento.', 'Atenção', { type: 'warning', confirmButtonText: 'Sim, reverter', cancelButtonText: 'Não' })
                .then(() => this.acaoAprovacao('desaprovar', false, 'Aprovação revertida.'))
                .catch(() => {})
        },
        acaoAprovacao (acao, valor, msgOk) {
            if (!this.form.id) return
            this.salvandoAprovacao = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-aula/${acao}/${this.form.id}`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.salvandoAprovacao = false
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: msgOk, type: 'success' })
                this.form.aprovado = valor
                const item = this.planejamentos.find(x => x.id === this.form.id)
                if (item) item.aprovado = valor
            }).catch(e => { this.salvandoAprovacao = false; this.$store.commit('throwException', e) })
        },
        nomeTurma (turmaId) {
            const t = this.turmas.find(x => x.id == turmaId)
            return t ? t.nome : '—'
        },
        nomeDisciplina (turmaId, disciplinaId) {
            if (!disciplinaId) return '—'
            const t = this.turmas.find(x => x.id == turmaId)
            const d = (t && t.disciplinas) ? t.disciplinas.find(x => x.id == disciplinaId) : null
            return d ? d.nome : '—'
        },
        formatarData (v) {
            return v ? this.$moment(v).format('DD/MM/YYYY') : '—'
        },
        // "início a fim" quando é um período; senão, só a data.
        intervaloData (p) {
            if (p.data_fim && p.data_fim !== p.data) {
                return `${this.formatarData(p.data)} a ${this.formatarData(p.data_fim)}`
            }
            return this.formatarData(p.data)
        },
        truncar (txt) {
            if (!txt) return '—'
            return txt.length > 80 ? txt.substring(0, 80) + '...' : txt
        }
    }
}
</script>
